import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect, useState } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import Outputs from "@/pages/Outputs";
import SapImport from "@/pages/SapImport";
import RawMaterials from "@/pages/RawMaterials";
import Inventory from "@/pages/Inventory";
import Items from "@/pages/Items";
import ChangeLog from "@/pages/ChangeLog";
import EdiLog from "@/pages/EdiLog";
import Settings from "@/pages/Settings";
import Partners from "@/pages/Partners";
import Planning from "@/pages/Planning";

function App() {
  return (
    <AuthProvider>
      <TooltipProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="orders" element={<Orders type="customer" />} />
            <Route path="replenishment" element={<Orders key="rep" type="replenishment" />} />
            <Route path="orders/:id" element={<OrderDetail />} />
            <Route path="outputs" element={<Outputs />} />
            <Route path="sap-import" element={<SapImport />} />
            <Route path="raw-materials" element={<RawMaterials />} />
            <Route path="inventory" element={<Inventory />} />
            <Route path="items" element={<Items />} />
            <Route path="change-log" element={<ChangeLog />} />
            <Route path="edi" element={<EdiLog />} />
            <Route path="settings" element={<Settings />} />
            <Route path="partners" element={<Partners />} />
            <Route path="planning" element={<Planning />} />
          </Route>
        </Routes>
      </BrowserRouter>
      </TooltipProvider>
      <ThemedToaster />
    </AuthProvider>
  );
}

const ThemedToaster = () => {
  const [t, setT] = useState(localStorage.getItem("ep-theme") || "dark");
  useEffect(() => {
    const f = () => setT(localStorage.getItem("ep-theme") || "dark");
    window.addEventListener("ep-theme", f);
    return () => window.removeEventListener("ep-theme", f);
  }, []);
  return <Toaster theme={t} position="bottom-right" />;
};

export default App;
